<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
        <div *ngIf="!viewaboutSeec" class="card-body">


            <h1 class="font-weight-bold text-primary mb-7 mt-15">مقدمة : </h1>
            <p class="h5 line-height-xl text-dark-65">
              ينفذ المركز السعودي لكفاءة الطاقة العديد من المبادرات لتحسين استهلاك الطاقة في جميع القطاعات ( صناعي – مباني –
              نقل بري ) والتي تستهلك في مجملها مايزيد عن (90%) من الطاقة الأولية بالمملكة.
            </p>
            <p class="h5 line-height-xl text-dark-65">
              ويستهلك قطاع المباني لوحده 29% من إجمالي الاستهلاك، وتتوزع نسب الاستهلاك في هذا القطاع على المباني السكنية
              (%44) المباني التجارية (%16) المباني الحكومية (%14).
            </p>

            <h1 class="font-weight-bold text-primary mb-7 mt-15"> استهلاك الطاقة في الجهات
              الحكومية :
            </h1>
            <p class="h5 line-height-xl text-dark-65">
              تشير نسب استهلاك الطاقة في الجهات الحكومية إلى أن هناك نسب استهلاك عالية للطاقة ( كهرباء – وقود )،

              الأمر الذي
              استدعى العمل

              على تخفيض هذا الاستهلاك لتحقيق وفورات جيدة يمكن توجيهها لجوانب تنموية مفيدة للمواطن

              والوطن، حيث صدرت خمسة أوامر سامية جميعها تؤكد على الجهات الحكومية أهمية تحسين كفاءة استهلاك الطاقة في مبانيها.
            </p>

            <h1 class="font-weight-bold text-primary mt-15">مضمون الأوامر السامية : </h1>
            <div class="h5 line-height-xl text-dark-65 pl-10">
              <div class="border-bottom py-10">
                <h3 class="lightGreen mb-0">رقم 5604</h3>
                <p class="small">تاريخ 5 / 2 / 1439هـ</p>
                <div>
                  <ul>
                    <li class="my-1">
                      التأكيد الجهات الحكومية :
                    </li>
                  </ul>
                </div>
                <ul style="margin-right: 30px;">
                  <li class="my-1">
                    الالتزام بمواصفات كفاءة الطاقة عند إعداد الشروط الخاصة بمشروعاتها، واختيار الأجهزة الأكثر كفاءة

                  </li>

                  <li class="my-1">اتباع اشتراطات كود البناء السعودي (القسم 601) عند تصميم مبانيها الجديدة ، وطلب الأجهزة
                    عالية الكفاءة ضمن متطلبات المشاريع الجديدة </li>
                  <li class="my-1">العمل على رفع كفاءة استهلاك الكهرباء في المباني القائمة، وذلك من خلال العمل على العديد من
                    الاجراءات. </li>
                  <li class="my-1">تزويد المركز بالبيانات المتعلقة بالاستهلاك.</li>
                  <li class="my-1">التنسيق مع المركز لإعداد وتنفيذ برامج توعوية لمنسوبيها</li>
                </ul>
              </div>
              <div class="border-bottom py-10">
                <h3 class="lightGreen mb-0">رقم 53324</h3>
                <p class="small">تاريخ 21/ 9 / 1440هـ</p>

                <div>
                  <ul>
                    <li class="my-1">
                      قيام الجهات الحكومية بتزويد المركز:
                    </li>
                  </ul>
                </div>

                <ul style="margin-right: 30px;">
                  <li class="my-1"> بالبيانات المتعلقة بالمباني التابعة لها واستهلاك
                    الطاقة </li>
                  <li class="my-1">تقارير نصف سنوية عما تم عمله من قبلها في شأن تحسين كفاءة استهلاك الطاقة وخططها في هذا
                    المجال</li>
                </ul>

                <div>
                  <ul>
                    <li class="my-1">
                      قيام المركز السعودي لكفاءة الطاقة بالتنسيق مع مركز تحقيق كفاءة الانفاق برفع ما يلزم من تقارير
                      استهلاك الجهات الحكومية للكهرباء بشكل نصف سنوي
                    </li>
                  </ul>
                </div>

              </div>
              <div class="border-bottom py-10">
                <h3 class="lightGreen mb-0">رقم 20726</h3>
                <p class="small">وتاريخ 28 / 3 / 1441هــ</p>
                <div>

                  <ul>
                    <li class="my-1">
                      (أولاً) إلزام الجهات الحكومية بالتنسيق مع المركز السعودي لكفاءة الطاقة، وذلك فيما يأتي:
                    </li>
                  </ul>
                </div>
                <ul style="margin-right: 30px;">
                  <li class="my-1">تقديم خطة عمل للمركز توضح فيها الآلية المستخدمة لكيفية رفع كفاءة استهلاك الوقود لديها
                    لتحقيق كفاءة الطاقة</li>
                  <li class="my-1">تحقيق المتطلبات والمعايير المحددة التي تم وضعها من قبل المركز لتحقيق كفاءة استهلاك
                    الوقود، وأن يراعى عند شراء الأجهزة والمعدات والمركبات الجديدة للجهات الحكومية معيار رفع كفاءة استهلاك
                    الوقود</li>
                </ul>
              </div>
              <div class="border-bottom py-10">
                <h3 class="lightGreen mb-0">رقم 61773</h3>
                <p class="small">تاريخ 18/ 11 / 1441هـ</p>



                <div>

                  <ul>
                    <li class="my-1">
                      قيام الجهات الحكومية بإنشاء فريق عمل معني بترشيد استهلاك الطاقة في الجهة، يرتبط بالمسؤول الأول فيها
                      -أو
                      من ينيبه- يتولى ما يأتي:
                    </li>
                  </ul>
                </div>



                <ul style="margin-right: 30px;">
                  <li class="my-1">متابعة تنفيذ القرارات والأوامر المتعلقة بترشيد استهلاك الطاقة (ويشمل ذلك الوقود
                    والكهرباء)</li>
                  <li class="my-1">تحديد مستويات استهلاك الطاقة، وإعداد خطة عمل تحدد فرص الترشيد وتنفيذها</li>
                  <li class="my-1">تزويد المركز السعودي لكفاءة الطاقة بالبيانات المطلوبة المتعلقة بترشيد استهلاك الطاقة،
                    وتنفيذ ما يصدر عنه من معايير وبرامج</li>
                </ul>
              </div>
              <div class="py-10">
                <h3 class="lightGreen mb-0">رقم 66559</h3>
                <p class="small">تاريخ 12 / 12 / 1441هـ</p>



                <div>
                  <ul>
                    <li class="my-1">
                      التأكيد على الوزارات والأجهزة الحكومية والجهات التابعة لها او المرتبطة بها بالالتزام بما ورد في
                      الأمرين
                      رقم 5604 ورقم 53324
                    </li>
                  </ul>
                </div>



              </div>
            </div>

            <div class="h5 line-height-xl text-dark-65">
              <h1 class="font-weight-bold text-primary mb-7 mt-10">برنامج كفاءة الطاقة في الجهات
                الحكومية :</h1>
              <p class="h5 line-height-xl text-dark-65">
                تنفيذا للأوامر السامية فقد سعى المركز السعودي لكفاءة الطاقة لتمكين الجهات الحكومية لكي ترفع كفاءة استهلاكها
                للطاقة في جميع منشآتها ومقارها ، وتزويد هذه الجهات بالوسائل المساعدة على ذلك من خلال عقد ورش عمل فنية مع
                المختصين في فرق كفاءة الطاقة بهذه الجهات، وتزويدهم بالنماذج والأدلة الإرشادية اللازمة، بالإضافة لتقديم الدعم
                اللازم لتنفيذ البرامج والأنشطة التوعوية بهدف رفع الوعي لدى منسوبيها بأهمية الترشيد ورفع كفاءة الطاقة، فضلاً
                عن
                تقديم برامج تدريبية لمنسوبي الجهات الحكومية بهدف رفع جداراتهم في مجالات كفاءة الطاقة.
              </p>
              <h2 class="font-weight-bold text-primary  mb-7 mt-15">الجانب الفني :</h2>
              <ul>
                <li class="my-1">عقد ورش عمل لفرق إدارة الطاقة لتوضيح المهام والمسؤوليات لتنفيذ الأوامر السامية.</li>
                <li class="my-1">تقديم استشارات فنية دائمة لتحقيق النتائج والأهداف المرغوبة في تحسين كفاءة الطاقة.</li>
                <li class="my-1">تطوير بطاقات الأداء لتحفيز فرق عمل كفاءة الطاقة في الجهات.</li>
                <li class="my-1">تزويد الجهات الحكومية بالمعايير والأدلة وبرامج المساعدة ومن أمثلتها برنامج إدارة الطاقة و
                  الدليل التنفيذي لبرنامج إدارة الطاقة و نموذج خطط العمل لترشيد استهلاك الطاقة.</li>
              </ul>
            </div>
        </div>
      <div *ngIf="viewaboutSeec" class="card-body">

        <h1 class="font-weight-bold text-primary mb-7 mt-15">{{ l('CenterPrefDescription') }} </h1>
        <p class="container htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="viewaboutSeec.centerPrefDescription">

        </p>
        <br>
        <h1 class="font-weight-bold text-primary mb-7 mt-15">{{ l('AboutProgramDescription') }} </h1>
        <p class="container htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="viewaboutSeec.aboutProgramDescription">

        </p>
        <br>
        <h1 class="font-weight-bold text-primary mb-7 mt-15">{{ l('TechnicalSideDescription')  }} </h1>
        <p class="container htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="viewaboutSeec.technicalSideDescription">

        </p>
        <br>
        <h1 class="font-weight-bold text-primary mb-7 mt-15">{{ l('AwarenessSideDescription')  }} </h1>
        <p class="container htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="viewaboutSeec.awarenessSideDescription">

        </p>
        <br>
        <h1 class="font-weight-bold text-primary mb-7 mt-15">{{ l('TraningSideDescription')  }} </h1>
        <p class="container htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="viewaboutSeec.traningSideDescription">

        </p>
    </div>

      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>
